import { useState, useEffect } from "react"

import { Trash2 } from "lucide-react"

import { ProjectFilterPropertySection } from "@/components/filters/ProjectFilterPropertySection"
import { ProjectSearchPropertySection } from "@/components/filters/ProjectSearchPropertySection"
import { Button } from "@/components/ui/button"
import { FilterProperty, PropertyFacet } from "@/models/facets"

const INITIAL_SEARCH_FILTERS = {
    properties: {},
    matches: {}
}

interface ProjectFiltersPanelProps {
    properties?: PropertyFacet[]
    filters?: FilterProperty[]
    onFiltersChange: (filters: any) => void
}
export function ProjectFiltersPanel({ properties, filters, onFiltersChange }: Readonly<ProjectFiltersPanelProps>) {
    const [searchFilters, setSearchFilters] = useState(INITIAL_SEARCH_FILTERS)
    const [clearFilters, setClearFilters] = useState(0)

    const handleOnClearFilters = () => {
        setSearchFilters({
            properties: {},
            matches: {}
        })
        setClearFilters(prev => prev + 1)
    }

    const handlePropertiesChange = (properties: any) => {
        setSearchFilters({ ...searchFilters, properties: { ...properties } })
    }

    const handleMatchChange = (matches: any) => {
        setSearchFilters({ ...searchFilters, matches: { ...matches } })
    }

    const handleFiltersChange = (filters: any) => {
        const newProperties = { ...searchFilters.properties, ...filters.properties }
        const newMatches = { ...searchFilters.matches, ...filters.matches }

        // Remove keys with undefined values (cleared fields)
        Object.keys(newProperties).forEach(key => {
            if (newProperties[key] === undefined) {
                delete newProperties[key]
            }
        })
        Object.keys(newMatches).forEach(key => {
            if (newMatches[key] === undefined) {
                delete newMatches[key]
            }
        })

        setSearchFilters({ properties: newProperties, matches: newMatches })
    }

    useEffect(() => {
        onFiltersChange(searchFilters)
    }, [searchFilters, onFiltersChange])

    return (
        <div className="h-full flex min-w-[var(--filterbar-width)] max-w-[var(--filterbar-width)] flex-col bg-sidebar text-sidebar-foreground border-r border-sidebar-border">
            <div className="h-full flex flex-col overflow-auto">
                {properties && <ProjectSearchPropertySection properties={properties} onClear={clearFilters} onSelection={handlePropertiesChange} onMatchChange={handleMatchChange} />}
                {filters && <ProjectFilterPropertySection properties={filters} onClear={clearFilters} onFilterChange={handleFiltersChange} />}
            </div>
            <div className="w-full p-2 text-center">
                {
                    (Object.keys(searchFilters?.properties ?? {}).length > 0 || Object.keys(searchFilters?.matches ?? {}).length > 0) && (
                        <Button onClick={handleOnClearFilters} className="mt-2 w-full hover:cursor-pointer" variant="outline">
                            <span className="flex items-center justify-center gap-2">
                                <Trash2 />
                                Clear Filters
                            </span>
                        </Button>
                    )
                }
            </div>
        </div>
    )
}